import { render, staticRenderFns } from "./StepNav.vue?vue&type=template&id=54ca273a"
import script from "./StepNav.vue?vue&type=script&lang=js"
export * from "./StepNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports